import { Alert } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
type CollectionErrorAlertProps = {
  isError: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorData: any;
  entityName: string;
};

/**
 * Component that displays error messages for API calls
 * Extracts error details from the API error response
 */
export const CollectionErrorAlert = ({
  isError,
  errorData,
  entityName,
}: CollectionErrorAlertProps) => {
  const { t } = useTranslation();

  if (!isError) return null;

  const errorMessage =
    errorData?.data?.message ||
    errorData?.error ||
    t('Error fetching {{entity}} data', { entity: entityName });

  return (
    <Alert severity='error' sx={{ mb: 2 }}>
      {t('{{entity}} Error', { entity: entityName })}: {errorMessage}
    </Alert>
  );
};
